import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseContacts } from 'src/app/models/response-contacts';
import { ReturnMessage } from 'src/app/models/return-message';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  public static readonly CONTACT_NAME: string = "contactName";
  public static readonly EMAIL: string = "email";
  public static readonly PHONE_NUMBER: string = "phoneNumber";

  private apis = {
    getCustomerAddressContact: 'utility/AutocompleteCustomerAddressContact/'
  }

  constructor(private http: HttpClient) { }

  getCustomerAddressContact(post: { searchAll: boolean, searchTerm: string, customerNumber: string, addressCode: string, searchField: string}) 
  : Observable<ReturnMessage<ResponseContacts[]>> {
    let postFilter = {
      searchAll: post.searchAll,
      search: post.searchTerm,
      optionalData: {
        "customerNumber": post.customerNumber,
        "addressCode": post.addressCode,
        "searchFieldName": post.searchField
      }
    } as PostFilterFields;
    return this.http.post<ReturnMessage<ResponseContacts[]>>(this.apis.getCustomerAddressContact, postFilter);
  }
}